import { render, staticRenderFns } from "./ControlePedidosCardKanban.vue?vue&type=template&id=0e576500"
import script from "./ControlePedidosCardKanban.vue?vue&type=script&lang=js"
export * from "./ControlePedidosCardKanban.vue?vue&type=script&lang=js"
import style0 from "./ControlePedidosCardKanban.vue?vue&type=style&index=0&id=0e576500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports